if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

  this.handleErrorMessage();

  this.submitButton.setAttribute('aria-disabled', true);
  this.submitButton.classList.add('loading');
  this.querySelector('.loading__spinner').classList.remove('hidden');

  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];

  const formData = new FormData(this.form);
  const mainVariantId = formData.get('id');
  const bundleId = mainVariantId;
  const freeVariantId = formData.get('properties[_free_product_variant]');

  // Add main product first
  const mainProductData = new FormData();
  mainProductData.append('id', mainVariantId);
  mainProductData.append('quantity', formData.get('quantity') || 1);
  mainProductData.append('properties[_bundle_id]', bundleId);

  if (this.cart) {
    const sections = this.cart.getSectionsToRender().map(s => s.id);
    mainProductData.append('sections', sections);
    mainProductData.append('sections_url', window.location.pathname);
    this.cart.setActiveElement(document.activeElement);
  }

  config.body = mainProductData;

  fetch(`${routes.cart_add_url}`, config)
    .then(r => r.json())
    .then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButtonText.classList.add('hidden');
        const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
        if (soldOutMessage) soldOutMessage.classList.remove('hidden');
        this.error = true;
        return;
      }

      // After main product is added, add free product if exists
  const addFreeProduct = async () => {
  if (!freeVariantId) return response;

  // 1️⃣ Get current cart
  const cart = await fetch('/cart.js').then(r => r.json());

  // 2️⃣ Check if matching free product already exists
  const freeExists = cart.items.some(item =>
    item.variant_id == freeVariantId &&
    item.properties?._bundle_id == bundleId &&
    item.properties?.free_product === 'Free'
  );

  // 3️⃣ If exists → do nothing
  if (freeExists) return response;

  // 4️⃣ Else add free product ONCE
  const freeProductData = new FormData();
  freeProductData.append('id', freeVariantId);
  freeProductData.append('quantity', 1);
  freeProductData.append('properties[free_product]', 'Free');
  freeProductData.append('properties[_bundle_id]', bundleId);

  if (this.cart) {
    const sections = this.cart.getSectionsToRender().map(s => s.id);
    freeProductData.append('sections', sections);
    freeProductData.append('sections_url', window.location.pathname);
  }

  const freeConfig = fetchConfig('javascript');
  freeConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete freeConfig.headers['Content-Type'];
  freeConfig.body = freeProductData;

  return fetch(`${routes.cart_add_url}`, freeConfig).then(r => r.json());
};


      addFreeProduct().then(finalResponse => {
        this.error = false;
        if (this.cart) {
          CartPerformance.measure("add:paint-updated-sections", () => {
            this.cart.renderContents(finalResponse); // render cart drawer
            if (typeof this.cart.open === 'function') this.cart.open(); // open drawer
          });
        } else {
          window.location = window.routes.cart_url;
        }
      });
    })
    .catch(e => console.error(e))
    .finally(() => {
      this.submitButton.classList.remove('loading');
      if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      this.querySelector('.loading__spinner').classList.add('hidden');
      CartPerformance.measureFromEvent("add:user-action", evt);
    });
}


      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
